// corp_card: 법인카드, psnl_card: 개인카드, cash : 현금
export const PAYMENT_TYPE = [
  {
    label: "법인카드",
    value: "corp_card",
  },
  {
    label: "개인카드",
    value: "psnl_card",
  },
  {
    label: "현금",
    value: "cash",
  },
];

export const APPR_STATUS = [
  { label: "결재대기중", value: "pending" },
  { label: "결재진행중", value: "in_progress" },
  { label: "결재완료", value: "approved" },
  { label: "반려됨", value: "denied" },
  { label: "취소됨", value: "canceled" },
];

export const EXPENSE_SEARCH_LIST = [
  { label: "개인카드", value: "psnlCardUse" },
  { label: "법인카드", value: "corpCardUse" },
  { label: "현금", value: "cashUse" },
];
